
<div v-if="site && contract">
    <f-title title="Prüfungskosten" />

    <v-row class="no-frame ">
        <v-col class="no-frame mr-2 pt-1">
            <f-read-only-field
                :label       = "$t('contract.zus.costsMainAudit')"
                :value       = "contract.unit ? toMoney(contract.unit.mainAudit) : '---'"
                :align-right = "true"
                filled
                dense
            />
        </v-col>
        <v-col class="no-frame ml-2 pb-2 pt-1">
            <f-read-only-field
                :label       = "$t('contract.zus.costIntermediateAudit')"
                :value       = "contract.unit ? toMoney(contract.unit.intermediateAudit) : '---'"
                :align-right = "true"
                filled
                dense
            />
        </v-col>
    </v-row>

    <v-row class="no-frame ">
        <v-col class="no-frame mr-2 pt-1">
            <f-read-only-field
                :label       = "$t('contract.zus.costAuditAfterDefects')"
                :value       = "contract.unit ? toMoney(contract.unit.auditAfterDefects) : '---'"
                :align-right = "true"
                filled
                dense
            />
        </v-col>
        <v-col class="no-frame ml-2 pb-2 pt-1">
            <f-read-only-field
                :label       = "$t('contract.zus.costAuditAfterChange')"
                :value       = "contract.unit ? toMoney(contract.unit.auditAfterChange) : '---'"
                :align-right = "true"
                filled
                dense
            />
        </v-col>
    </v-row>
</div>
